// Copyright (c) 2016 Deere & Company

import EmissionsPartSearchReport from '../../../reports/emissions-part-search/state-connector';

export default {
    component: EmissionsPartSearchReport,
    name: 'EMISSIONS_PART_SEARCH',
    path: 'emissions-part-search'
};



// WEBPACK FOOTER //
// ./src/routes/claims/reports/emissions-part-search.js